import React from 'react';
import styled from 'styled-components';
import { Card, Icon } from 'semantic-ui-react';
import { formatNumber } from '~/utils/helpers';

const StyledCard = styled(Card)`
  &&& {
    width: 180px;
    padding: 1em;
    box-shadow: none !important;
    border-radius: 8px;
    text-align: center;
    background: transparent !important;
  }
`;

const Percentage = styled.div<{ $isPositive: boolean }>`
  font-size: 28px !important;
  color: ${props => props.$isPositive ? '#21ba45' : '#db2828'};
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface Props {
  value: string;
  isPositive: boolean;
}

const PercenteIndicator: React.FC<Props> = ({ value, isPositive }) => {

  const normalizedValue = value.replace(',', '.');
  const formattedValue = Math.abs(parseFloat(normalizedValue)).toFixed(1);

  return (
    <StyledCard>
      <Percentage $isPositive={isPositive}>
        <Icon
          size="large"
          name={isPositive ? 'triangle up' : 'triangle down'}
          color={isPositive ? 'green' : 'red'}
        />
        {`${formatNumber(formattedValue, 1)} %`}
      </Percentage>
    </StyledCard>
  );
};

export default PercenteIndicator;